<!--<ngx-avatar-->
<!--  matCardAvatar-->
<!--  [class]="class"-->
<!--  [size]="size"-->
<!--  [name]="billerNameShort"-->
<!--  [src]="logoCdnUrl + billerCode + logoSuffix"-->
<!--  [bgColor]="billerColorMap[billerCode]"-->
<!--&gt;</ngx-avatar>-->
<!--//todo-->

<app-avatar
  matCardAvatar
  [class]="class"
  [label]="billerNameShort.substring(0, 1)"
  [width]="size? (size.toString() + 'px') : '25px'"
  [height]="size? (size.toString() + 'px') : '25px'"
>

</app-avatar>
